module.exports = __webpack_public_path__ + "img/hs-03-ex.aa9dbdc2.svg";